<div class="warrantyContainer constrained-width">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="full-width" style="font-size: 100%;">
        @if (!applicationService.hideRegistrationEnabled && !warrantyForm.controls.claimId.value) {
          <a [routerLink]="['/find-claim']" [queryParams]="{company: company()}" class="float-right">
            Lookup Registration Information
          </a>
        }
        <br>
        @if(warrantyForm.controls.warrantyStatus.value){
        <h4 class="row">
          <div class="grow">
            <span>Warranty Status: {{warrantyForm.controls.warrantyStatus.value}}</span>
          </div>
          <div>
            Claim # {{warrantyForm.controls.helpDeskTicket.value}}
          </div>
        </h4>
        }
        @if(caseCompanyIfExists(company()) === Company.Marucci){<ng-container *ngTemplateOutlet="marucciHeader"></ng-container>}
        @if(caseCompanyIfExists(company()) === Company.Victus){<ng-container *ngTemplateOutlet="victusHeader"></ng-container>}
        @if(caseCompanyIfExists(company()) === Company.Baum){<ng-container *ngTemplateOutlet="baumHeader"></ng-container>}
      </mat-card-title>
    </mat-card-header>

    <app-warranty-form
      [warrantyForm]="warrantyForm"
      [mode]="mode"
      [editable]="editable"
      [canCreateClaim]="canCreateClaim()"
      [processing]="processing()"
      [purchasedSite]="purchasedSite"
      [company]="company"
      [companySite]="companySite"
      [constructionType]="constructionType"
      [levelsOfPlay]="levelsOfPlay"
      [places]="places"
      [filteredModels]="filteredModels"
      [selectedSku]="selectedSku"
      [colors]="colors"
      [sizes]="sizes"
      (submitWarranty)="onSubmit()"
      (createClaim)="createClaim()"
      (modelChanged)="onModelChange($event)"
      (modelSelected)="onModelSelection($event)"
      (batLengthChanged)="onBatLengthChange($event)"
      (batColorChanged)="onBatColorChange($event)"
      (countryChanged)="onCountryChange($event)"
      (imageLoaded)="onImageLoaded($event)"
    ></app-warranty-form>

    @if(caseCompanyIfExists(company()) === Company.Marucci){<ng-container *ngTemplateOutlet="marucciFooter"></ng-container>}
    @if(caseCompanyIfExists(company()) === Company.Victus){<ng-container *ngTemplateOutlet="victusFooter"></ng-container>}
    @if(caseCompanyIfExists(company()) === Company.Baum){<ng-container *ngTemplateOutlet="baumFooter"></ng-container>}

    <ng-container *ngIf="applicationService.isAdmin()">
      <mat-icon (click)="showRaw = !showRaw" (keydown)="showRaw = !showRaw">bug_report</mat-icon>
      <div *ngIf="showRaw">
        <pre>Record Value:
          {{warranty | json}} </pre>
        <hr>
        <pre>Form Value:
          {{warrantyForm.getRawValue() | json}} </pre>
        <hr>
        <pre>Form Errors:
          {{warrantyForm.errors | json}} </pre>
        invalid: {{warrantyForm.invalid}}
      </div>
    </ng-container>
  </mat-card>
</div>

<ng-template #marucciHeader>
  <div class="center reverse-colors">
    <img [src]="companySite().logo" alt="logo" class="logoImage"> &nbsp;
  </div>
</ng-template>

<ng-template #marucciFooter>
</ng-template>

<ng-template #victusHeader>
  <div class="center reverse-colors">
    <img [src]="companySite().logo" alt="logo" class="logoImage"> &nbsp;
  </div>
</ng-template>

<ng-template #victusFooter>
</ng-template>

<ng-template #baumHeader>
  <div class="center reverse-colors">
    <img [src]="companySite().logo" alt="logo" class="logoImage"> &nbsp;
  </div>
</ng-template>

<ng-template #baumFooter>
</ng-template>
